import {
  GreyGrey60,
  Primary12Regular,
  Spinner,
  Box,
  Flex
} from '@sequencehq/core-components'
import useInfiniteScroll from 'react-infinite-scroll-hook'

export const ListWithPagination = (props: {
  isLoading: boolean
  hasNextPage: boolean
  fetchNextPage: () => void
  onClick?: () => void
  margin?: number
  children: React.ReactNode
}) => {
  const [infiniteRef] = useInfiniteScroll({
    loading: props.isLoading,
    hasNextPage: props.hasNextPage,
    onLoadMore: props.fetchNextPage,
    /**
     * Load more when we approach 1 rows from the bottom
     */
    rootMargin: `0px 0px 200px 0px`
  })

  return (
    <Flex
      flexDir="column"
      gap="2px"
      minHeight="100%"
      onClick={props.onClick}
      data-testid="listWithPagination"
    >
      {props.children}
      {props.hasNextPage && (
        <Flex
          ref={infiniteRef}
          gap="8px"
          alignItems="center"
          justifyContent="center"
          marginTop="8px"
        >
          <Spinner color={GreyGrey60} height="16px" width="16px" />
          <Box {...Primary12Regular} color={GreyGrey60}>
            Loading
          </Box>
        </Flex>
      )}
    </Flex>
  )
}
